export enum PartyTypeEnum {
	BUSINESS = 'BUSINESS',
	INDIVIDUAL = 'INDIVIDUAL',
}
